import axios from "axios";

const axiosRequest = axios.create({
  baseURL: 'https://backend.npcmed.ir',
});


export default axiosRequest;